<template>
<!--  <page-header-wrapper>-->
    <a-modal
      :visible="visible"
      width="80%"
      :footer="null"
      style="padding: 20px"
      @cancel="cancel">
      <!-- 条件搜索 -->
      <a-divider orientation="left">
      </a-divider>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="视频id" prop="videoId">-->
<!--                <a-input v-model="queryParam.videoId" placeholder="请输入视频id" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="演员姓名" prop="performerName">
                <a-input v-model="queryParam.performerName" placeholder="请输入演员姓名" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="演員頭像" prop="performerAvatar">-->
<!--                  <a-input v-model="queryParam.performerAvatar" placeholder="请输入演員頭像" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="排序" prop="sort">-->
<!--                  <a-input v-model="queryParam.sort" placeholder="请输入排序" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否禁用 0-否 1-是" prop="isBan">-->
<!--                  <a-input v-model="queryParam.isBan" placeholder="请输入是否禁用 0-否 1-是" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(videoId)" v-hasPermi="['videoPerformer:videoPerformer:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['videoPerformer:videoPerformer:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['videoPerformer:videoPerformer:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['videoPerformer:videoPerformer:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <img v-if="record.performerAvatar" slot="performerAvatar" slot-scope="text, record" :src="record.performerAvatar" style="width: 48px;height: 48px;" @click="handleRecordPreview(record.performerAvatar)" alt="none"/>
        <span slot="isBan" slot-scope="text, record">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.isBan == 1" @change="changeIsBan($event,record)"/>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['videoPerformer:videoPerformer:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined,videoId)" v-hasPermi="['videoPerformer:videoPerformer:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['videoPerformer:videoPerformer:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['videoPerformer:videoPerformer:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl"/>
      </a-modal>
      <!-- 分页 -->
      <div class="flex align-center justify-end" style="padding-top: 20px;">
        <a-pagination
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>

    </a-modal>
<!--  </page-header-wrapper>-->
</template>

<script>
import { pageVideoPerformer,listVideoPerformer, delVideoPerformer,changeIsBen } from '@/api/shortVideo/video/videoPerformer'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'VideoPerformer',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      videoId: '',
      //预览封面
      previewImageVisible: false,
      previewUrl: '',
      // 高级搜索 展开/关闭
      advanced: false,
      visible: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        videoId: null,
        performerName: null,
        performerAvatar: null,
        sort: null,
        isBan: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '視頻id',
        //   dataIndex: 'videoId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '演员姓名',
          dataIndex: 'performerName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '演员头像',
          dataIndex: 'performerAvatar',
          ellipsis: true,
          scopedSlots: { customRender: 'performerAvatar' },
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否禁用',
          dataIndex: 'isBan',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isBan' }
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    // this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询视频演员清单 */
    getList () {
      this.loading = true
      this.visible=true
      this.queryParam.videoId=this.videoId
     pageVideoPerformer(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    cancel() {
      this.queryParam.videoId = null
      this.visible = false
    },
    getVideoPerformer(videoId) {
      this.videoId = videoId
      this.getList()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },



    changeIsBan(e, record) {
      record.isBen = e ? 1 : 0
      changeIsBen(record).then(response => {
        this.$message.success(
          '操作成功'
        )
        this.getList()
        // eslint-disable-next-line no-return-assign
        return record.isBen = e ? 1 : 0
      })
    },

    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoId: undefined,
        performerName: undefined,
        performerAvatar: undefined,
        sort: undefined,
        isBan: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delVideoPerformer(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids清单
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('videoPerformer/video-performer/export', {
            ...that.queryParam
          }, `视频演员_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
}
</script>
